export enum BadgeTypeEnum {
  status = 0,
  link = 1,
  clickable = 2,
  trafficLigth = 3,
}
